/**
 * CetusEd Community Portal — Header Navigation
 *
 * COMPLIANCE: Navigation links are organized by feature domain. The header
 *   displays the authenticated user's name and provides a logout action.
 *   Logout terminates the session and clears the stored auth token.
 */

import React, { useCallback } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';

export const Header: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    auth.logout();
    navigate('/login', { replace: true });
  }, [auth, navigate]);

  return (
    <header className="community-header">
      <div className="header-brand">
        <NavLink to="/" className="header-logo">
          CetusEd
        </NavLink>
        <span className="header-subtitle">Community Portal</span>
      </div>

      <nav className="header-nav" aria-label="Main navigation">
        <NavLink to="/documents" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
          Documents
        </NavLink>
        <NavLink to="/messages" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
          Messages
        </NavLink>
        <NavLink to="/calendar" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
          Calendar
        </NavLink>
        <NavLink to="/files" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
          Files
        </NavLink>
      </nav>

      <div className="header-user">
        <NavLink to="/profile" className="header-profile">
          {auth.user?.name || 'Profile'}
        </NavLink>
        <button
          className="header-logout"
          onClick={handleLogout}
          aria-label="Sign out"
        >
          Sign Out
        </button>
      </div>
    </header>
  );
};
